import { Button, Checkbox, Container, FormControlLabel, Grid, InputAdornment, TextField } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check';
import axios from 'axios'
import React, { useContext, useState, useRef, useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext';
import { getCredit } from '../helper/APIcalls';
import PageHeader from '../helper/PageHeader'
import { withTranslation } from 'react-i18next';



// Page for user to enter the DVD/Zoom code
// the code is then verified
// if the code is good, and the type is DVD, brings up the affadavit
// if Zoom and code good, skips affadavit
// if code bad brings up back button
// after brings up confirm payment
const EnterCode = props => {
    const {t} = props;
    const affadavitMessage = t('EnterCode.AffidavityMessage')
    const [code, setCode] = useState({ value: '', valid: false })
    const [foundCourse, setFoundCourse] = useState({ course: null, valid: false, searched: false })
    const [checked, setChecked] = useState(false) // the chedk box for affadvit
    const [signature, setSignature] = useState('')
    const [currentCredit, setCurrentCredit] = useState(null)
    const submitting = useRef(false)

    const userMain = useContext(authContext)
    const user = userMain.user
    const history = useHistory()

    const locationState = history.location.state



    const course = useParams().course
    const valid = course === 'DVD' || course === 'Zoom'
    const displayLang = locationState.lang === 'English' ? 'English' : t('trainingCourses.spanish')

    useEffect(() => {
        async function grabCredit() {
            setCurrentCredit(await getCredit(user.username))
        }
        console.log("grad credit")
        grabCredit()
    },[user.username])


    const handleCode = (event) => {
        if (event.target.value.length > 10) return // prevent longer than 10 entries
        setCode({ value: event.target.value, valid: event.target.value.length >= 6 }) //minimum is 6 characters, max is 10
    }

    const onVerify = async () => {
        let res
        try {
            res = await axios.get('/api/userTraining/validate/' + code.value, {
                params: {
                    trainingType: course
                }
            })
        } catch (e) {
            console.log(e)
            console.log(e.response)
            if (e.response.status === 400)
                setFoundCourse({ course: null, valid: true, searched: true }) //expired
            else //400
                setFoundCourse({ course: null, valid: false, searched: true }) // not found or 500
            return
        }
        console.log(res)

        let temp = res.data.trainingCode

        // temp = temp[0]
        setFoundCourse({ course: temp, valid: temp.status === 1, searched: true })
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        console.log(submitting.current)
        if (!submitting.current) {
            submitting.current = true
            console.log("submitting")
            //await sleep(5000)
            if (locationState.transform) {
                await axios.post('/api/userTraining/convert/' + locationState.realID, {
                    // type: locationState.type,
                    type: course,
                    username: user.username,
                    language: locationState.lang,
                    courseId: locationState.id,
                    trainingCode: code.value,
                    trainingType: course,
                    signAffidavitName: signature
                }, { headers: { Authorization: userMain.accessToken } })

                history.push('/dashboard')
            }
            else {
                await axios.post('/api/userTraining/' + course, {
                        username: user.username,
                        language: locationState.lang,
                        courseId: locationState.id,
                        trainingCode: code.value,
                        signAffidavitName: signature
                    }, { headers: { Authorization: userMain.accessToken } });
                await axios.post('/api/credit/deduct/user/' + user.username, {
                        credit: 15,
                        notes: course === 'Zoom' ? 'Redeem for Zoom Class Test' : 'Redeem for DVD Test',
                        byUsername: user.username
                    }, { headers: { Authorization: userMain.accessToken } });

                userMain.updateIsTrainee(true);
                history.push({
                    pathname : '/dashboard/user/'+user.username,
                    state :{
                        afterRedeem : true
                    }
                });
            }
            submitting.current = false
        }
    }

    return (
        <>
            <PageHeader
                title={valid ? course === 'Zoom' ? t('EnterCode.ZoomTraining') + ' - ' + displayLang : t('EnterCode.DVDTraining') + ' - ' + displayLang: t('EnterCode.ZoomDVDTraining') + ' - ' + displayLang}
                cancel={history.goBack} 
            />
            {!valid || !locationState ? <h1>{t('EnterCode.InvalidID')}</h1> :
                <>
                    <Grid container spacing={3}>

                        <Container maxWidth="sm">
                        <p>{course === 'Zoom' ? t('EnterCode.ZoomText') : t('EnterCode.DVDText')}</p>
                            <TextField
                                label={course === 'Zoom' ? t('EnterCode.ZoomCode') : t('EnterCode.DVDCode')}
                                value={code.value}
                                onChange={handleCode}
                                error={!code.valid}
                                helperText={!code.valid ? course === 'Zoom' ? t('EnterCode.CodeMsgForZoom') : t('EnterCode.CodeMsgForDVD') : null}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {foundCourse.valid ? <CheckIcon /> : ""}
                                        </InputAdornment>
                                    )
                                }}
                                fullWidth
                            />

                        </Container>

                        <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button
                                disabled={!code.valid}
                                variant="outlined"
                                color="primary"
                                type="submit"
                                onClick={onVerify}
                            >
                                {t('EnterCode.VerifyCode')}
                            </Button>
                        </Grid>

                        {(foundCourse.searched && course === 'Zoom' )&& <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end", color: "red"}}>
                            {
                                foundCourse.course === null ? (foundCourse.valid ?  <p>{t('EnterCode.CourseHasExpired')}</p> : <p>{t('EnterCode.CourseCodeNotFound')}</p>) 
                                :  <></>
                                 
                            }
                        </Grid>}

                        {(foundCourse.searched && course === 'DVD' )&& <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end", color: "red"}}>
                            {
                                foundCourse.course === null ? (foundCourse.valid ?  <p>{t('EnterCode.DVDCodeIsInvalid')}</p> : <p>{t('EnterCode.DVDCodeNotFound')}</p>) 
                                :  <></>
                                 
                            }
                        </Grid>}
                        <br />

                        {(foundCourse.course && foundCourse.valid) &&
                            // <PageHeader title="Affadivit" />
                            <>
                                {course === 'DVD' &&
                                    <>
                                        <FormControlLabel
                                            control={<Checkbox color="primary" checked={checked} onChange={(event) => setChecked(event.target.checked)} name="checkStatement" />}
                                            label={affadavitMessage}
                                        />

                                        <br />

                                        <Container maxWidth="sm">
                                            <TextField
                                                label={t('EnterCode.Signature')}
                                                value={signature}
                                                onChange={(event) => setSignature(event.target.value)}
                                                fullWidth
                                            />
                                        </Container>
                                    </>
                                }
                                <br />
                                <br />
                                <br />
                                <br />
                                {!locationState.transform && <p> {t('EnterCode.OnContinue15CreditDeducted')}{currentCredit} {t('EnterCode.AfterConfirmation')}{currentCredit - 15} {t('EnterCode.Credit')}</p>}


                                <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                                    {/* Button is disabled only if course is DVD and the box is not checked or the signature is blank */}
                                    <Button
                                        disabled={course === 'DVD' && (!checked || signature === '')}
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        onClick={onSubmit}
                                    >
                                        {t('EnterCode.Continue')}
                                    </Button>
                                </Grid>



                            </>
                        }



                    </Grid>



                </>
            }

        </>
    )
}

export default withTranslation()(EnterCode);